import { submitBidTransaction } from '../containers/ListingPage/ListingPage.duck';
import { StatusCode } from './enums';
import { showToaster } from './genericHelpers';

export const handleBidTransaction = async params => {
  const { dispatch, history, routeConfiguration, setIsBidModalOpen, ...rest } = params || {};
  try {
    const response = await dispatch(submitBidTransaction(rest));
    if (response.statusCode === StatusCode.SUCCESS) {
      showToaster('success', 'Successfully submitted bid');
      setIsBidModalOpen(false);
    }
  } catch (error) {
    showToaster('error', 'Error while sending bid ');
  }
};
